/**
 * 登录页：邮箱+密码，400 message 直接展示；成功后回跳来源或首页。
 */
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/auth';
import { Button, Card, ErrorBox, Field, Input, errMsg } from '../components/ui';
import { Icon } from '../components/icons';

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const login = useAuth((s) => s.login);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError('请填写邮箱和密码');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await login({ email: email.trim(), password });
      const from = (location.state as { from?: string } | null)?.from;
      navigate(from ?? '/', { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 dark:bg-slate-950">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-600 text-white">
            <Icon name="sun" className="h-8 w-8" />
          </div>
          <h1 className="text-2xl font-semibold">追光宝盒</h1>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">事务 · 人脉 · 加密帐号保险箱</p>
        </div>
        <Card className="p-6">
          <form onSubmit={submit} className="space-y-4">
            <ErrorBox error={error} />
            <Field label="邮箱" required>
              <Input
                type="email"
                autoFocus
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
              />
            </Field>
            <Field label="密码" required>
              <Input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && submit(e as unknown as React.FormEvent)}
              />
            </Field>
            <Button type="submit" className="w-full" loading={busy}>
              登录
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-slate-500 dark:text-slate-400">
            还没有帐号？
            <Link to="/register" className="ml-1 font-medium text-indigo-600 hover:underline dark:text-indigo-400">
              注册
            </Link>
          </p>
        </Card>
      </div>
    </div>
  );
}
